// Generic CSV download helper
export function downloadCsvFromObjects(items, filename = 'download.csv', options = {}) {
  if (!Array.isArray(items) || items.length === 0) {
    return;
  }

  const headers = options.headers || Array.from(items.reduce((set, item) => {
    if (item && typeof item === 'object') Object.keys(item).forEach(k => set.add(k));
    return set;
  }, new Set()));

  const toExcelTextCell = (val) => {
    if (val === null || val === undefined) return '""';
    if (typeof val === 'object') {
      try { val = JSON.stringify(val); } catch (e) { val = String(val); }
    }
    const s = String(val).replace(/"/g, '""');
    const formula = `="${s}"`;
    const escapedFormula = formula.replace(/"/g, '""');
    return `"${escapedFormula}"`;
  };

  const rows = [];
  const headerRow = headers.map(h => `"${String(h).replace(/"/g, '""')}"`).join(',');
  rows.push(headerRow);
  items.forEach(item => {
    const row = headers.map(h => toExcelTextCell(item ? item[h] : ''));
    rows.push(row.join(','));
  });

  const csvContent = '\uFEFF' + rows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default { downloadCsvFromObjects };
